<template>
  <div>
    <div>
      <div class="vuse-content-wrapper mt-4">
        <v-row >
          <v-col cols="12" md="2" class="mt-0">
            <h2 class="ml-3 float-left">
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="xmlReport">
                      <ExcelIcon />
                    </v-btn>
                  </template>
                  <span>Download Table as CSV</span>
                </v-tooltip>
              </span>
             Statistiche
            </h2>
          </v-col>
          <!--
          <v-spacer />
          <v-col class="text-right" cols="12" md="2">
            <v-btn color="black" class="mr-3" dark @click.stop="timeframe_dialog = true" v-if="timeframe">
              <v-icon left dark>
                mdi-calendar
              </v-icon>
              {{formattedTimeframe}}
            </v-btn>
          </v-col> -->
        </v-row>
        <!--<template class="pt-6" v-if="errorid=='0001' && !loading">
          <no-data />  
        </template>-->

        <!--<v-row v-if="!orders">
          <no-data />  
        </v-row>-->
        <v-row class="ml-0">
          <v-col>
            <v-btn color="info" class="mr-5" @click="ShowChart('cpp')">CPP</v-btn>
            <v-btn color="warning" class="mr-5" @click="ShowChart('slot')">Slots</v-btn>
          </v-col>
        </v-row>        
        <v-row class="mt-2" align="top" justify="space-around">
          <v-col cols="12" md="12" class="pt-0 px-5">
            <v-card class="neu-glow">
              <line-chart v-if="!loading"
                  :data="data"
                  :options="settings.line_option"
                  :style="{ height: wHeight-223+'px' }"
                  class="pt-5"
                  id='Chart'
              />
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-dialog v-model="timeframe_dialog" max-width="500">
        <v-card>
          <v-card-title class="text-h5">
            Select Time Frame
          </v-card-title>
          <v-card-text>
            <v-date-picker class="mt-4" v-model="timeframe" :locale="user.locale" range full-width @change="change_timeframe"></v-date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="primary" @click="timeframe_dialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DoughnutChart from "@/components/ChartJS/DoughnutChart";
import LineChart from "@/components/ChartJS/LineChart";
import colors from "vuetify/lib/util/colors";
import _ from 'lodash'
export default {
  components: { LineChart,DoughnutChart},
  computed : {
    ...mapGetters(["user","settings","formattedTimeframe"]),
    buildChart()
    {
      this.data={};
      let datasetscount=0;
      console.log('258_payload',this.payload);
      this.orders=this.payload.table;
      this.data.labels = this.payload.labels;

      /*
      enabled = this.enabled_SuppliersAccounts;
      console.log('enabled',enabled);
      if (enabled.join()=='')
      {
        enabled=this.user.SuppliersAccounts.split(',')
      }*/
      
      let enabled=this.enabled_SuppliersAccounts==['All Suppliers']?[]:this.enabled_SuppliersAccounts;
      console.log(enabled);
      if (enabled.join()==''||enabled.join()=='All Suppliers')
      {
        enabled=this.user.SuppliersAccounts.split(',')
      }
      if (enabled.length>1 && enabled.includes(''))              
      {
        enabled=enabled.filter(f => f !== '');
      }
      console.log('enabled',enabled);

      this.data.datasets=[];
      enabled.forEach( e =>
        {           
          console.log('e',e);
          if (this.payload[e]!== undefined)
          {
            if (this.payload[e].reduce((a, b) => a + b, 0)>0)
            {
              this.settings.line_empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
              this.settings.line_empty_dataset.data = this.payload[e].map(x => this.convertedAmount(x));
              this.settings.line_empty_dataset.gradientStroke= lc.linecolors[e];
              this.data.datasets.push(JSON.parse(JSON.stringify(this.settings.line_empty_dataset)));
              datasetscount++
            }
          }
        }
      );
     // this.$refs.LineChart.rerender();
      if (datasetscount>1)
      {
          let e='total';
          this.settings.line_empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
          this.settings.line_empty_dataset.data = this.payload[e].map(x => this.convertedAmount(x));;
          this.settings.line_empty_dataset.gradientStroke = lc[e];
          this.data.datasets.unshift(JSON.parse(JSON.stringify(this.settings.line_empty_dataset)));
      }      
      return this.data;
    },
  },    
  data() {
    return {
      namespace: "Reports",
      page: "Shop",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      form:{},
      payload:{},
      loading: true,
      errorid: null,
      timeframe: [new Date().setMonth(new Date().getMonth()-1),new Date()],
      timeframe_dialog: false,
      data:
      {
        labels: [],
        datasets: [{
            label: 'Prenotazioni',
            data: [],
            backgroundColor: [],
            borderWidth: 1
        }]
      },
    };
  },
  created(){
    console.log(333,this.timeframe);
    this.loadData('cpp')
  },
  methods:
  {
    ShowChart(c)
    {
      this.loadData(c)
    },    
    change_timeframe(){
      if (this.timeframe[0]>this.timeframe[1])
      {
        let tmp=this.timeframe[0];
        this.timeframe[0]=this.timeframe[1]
        this.timeframe[1]=tmp;
      }
      this.$store.dispatch("set_timeframe", this.timeframe);  
      this.loadData();
    },
    refreshData(){
     let status=this.status[this.activeStatus].filter
     console.log(550,status,this.activeStatus,this.status);
      this.loadData(status);
    },
    async xmlReport(){
      let payload={"timeframe":this.timeframe.toString(),"sellers":this.activeeBayAccounts.toString()};
      window.location.href='/ajax/reports/revenue_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(chart=''){
      this.loading=true;
      this.timeframe=this.timeframe.length==0?[this.user.datefrom,this.user.dateto]:this.timeframe;
      //console.log('438_loadData',status,this.timeframe.toString(),this.activeeBayAccounts.toString(),this.activeCarriers,this.activeDepartures,this.activeStatus,this.status[this.activeStatus].filter);
      let datasetscount=0;
      //try{
          let lc=[[colors.red.base,colors.red.lighten3],[colors.pink.base,colors.pink.lighten3],[colors.purple.base,colors.purple.lighten3],[colors.indigo.base,colors.indigo.lighten3],[colors.blue.base,colors.blue.lighten3],[colors.cyan.base,colors.cyan.lighten3],[colors.teal.base,colors.teal.lighten3],[colors.green.base,colors.green.lighten3],[colors.lime.base,colors.lime.lighten3],[colors.yellow.base,colors.yellow.lighten3],[colors.amber.base,colors.amber.lighten3],[colors.orange.base,colors.orange.lighten3],[colors.brown.base,colors.brown.lighten3],[colors.red.lighten3,colors.red.darken3],[colors.pink.lighten3,colors.pink.darken3],[colors.purple.lighten3,colors.purple.darken3],[colors.indigo.lighten3,colors.indigo.darken3],[colors.blue.lighten3,colors.blue.darken3],[colors.cyan.lighten3,colors.cyan.darken3],[colors.teal.lighten3,colors.teal.darken3],[colors.green.lighten3,colors.green.darken3],[colors.lime.lighten3,colors.lime.darken3],[colors.yellow.lighten3,colors.yellow.darken3],[colors.amber.lighten3,colors.amber.darken3],[colors.orange.lighten3,colors.orange.darken3],[colors.brown.lighten3,colors.brown.darken3],[colors.grey.lighten3,colors.grey.darken3]];
          const payload={"action":"bookings","chart":chart,"timeframe":this.timeframe.toString()}
          const res = await this.$http.post('/stats/stats.php', payload );
          console.log(221,res)
          switch (res.data.errorid)
          {
            
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              let p = res.data.payload;
              let enabled=[];
              switch (chart)
              {
                case 'cpp':
                  enabled=['Prenotazioni','Coperti','cpp'];
                break;
                case 'slot':
                  enabled=['Coperti'];
                break;
              }
              console.log(229,enabled)
              this.data.datasets=[];
              this.data.labels = p.map(a => a['date'])
              enabled.forEach( (e,i) =>
                {           
                  console.log(233,e,p)
                  this.settings.line_empty_dataset.label=e;//e.charAt(0).toUpperCase() + e.slice;
                  this.settings.line_empty_dataset.data = p.map(a => a[e])
                  this.settings.line_empty_dataset.gradientStroke= lc[i];
                  this.data.datasets.push(JSON.parse(JSON.stringify(this.settings.line_empty_dataset)));
                  console.log(238,this.data.datasets)
                }
              );
              console.log(241);
              //this.$refs.LineChart.rerender();
              
            break;

            case '0403':
              this.$router.push('/error/403').catch(() => {});
            break;
            case '0007':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          console.log(259);       
      /*} catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }*/
      this.loading= false;
    }
  },
};
</script>
